/**
 * Client-safe authorization cache management
 * This file can be imported by client components without pulling in server-only dependencies.
 * 
 * @deprecated This utility does NOT affect React Query cache used by useAuth().
 * Use `useQueryClient().invalidateQueries({ queryKey: ['auth'] })` instead.
 * This is kept only for legacy compatibility.
 */

let cacheInvalidationTimestamp = Date.now();

/**
 * Clear the authorization cache by updating the invalidation timestamp
 * This signals to the useAuth hook that it should refetch data
 */
export function clearAuthCache() {
    cacheInvalidationTimestamp = Date.now();
    console.log('[Auth Cache] Cache cleared at:', cacheInvalidationTimestamp);
}

/**
 * Get the current cache invalidation timestamp
 */
export function getCacheInvalidationTimestamp(): number {
    return cacheInvalidationTimestamp;
}
